import { useSelector } from 'react-redux';

const useIsUSPlanholder = () => {
  let planholderData = {};
  const { data: userProfile } = useSelector((state) => state.app.profile);
  planholderData = userProfile;
  return {
    isHomeCountryUS: planholderData?.homeCountry === 'US',
    isCitizenshipUS:
      planholderData?.citizenshipCountry === 'US' || planholderData?.citizenship === 'US',
    isAddressUS: planholderData?.address?.country === 'US'
  };
};

export default useIsUSPlanholder;
